import React from 'react';
import { dragHandleIcon, CircleElement } from '@chordbaker/design';

interface DragHandleIconProps {
  size?: number;
  color?: string;
  className?: string;
}

const dots = dragHandleIcon.elements as CircleElement[];

/** Two columns of three dots: the section handle that opens the reorder sheet. */
const DragHandleIcon: React.FC<DragHandleIconProps> = ({
  size = dragHandleIcon.defaultSize,
  color = 'currentColor',
  className = '',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={dragHandleIcon.viewBox}
    fill={dragHandleIcon.fill}
    className={className}
    aria-hidden="true"
  >
    {dots.map(dot => (
      <circle key={`${dot.cx}-${dot.cy}`} cx={dot.cx} cy={dot.cy} r={dot.r} fill={color} />
    ))}
  </svg>
);

export default DragHandleIcon;
